(ns builder.index.view
  (:require [re-frame.core :as rf]
            [reagent.core :as r]
            [builder.index.model :as model]
            [builder.pages :as pages]
            [builder.sdc.posthog :as posthog]
            [toolkit.button :as button]
            [toolkit.spinner]
            [toolkit.empty]
            [toolkit.modal]
            [clojure.string :as str]
            #?(:cljs [goog.crypt.base64 :as base64])))

(defn questionnaires-grid [questionnaires]
  [:<>
   (for [q questionnaires]
     ^{:key (:id q)}
     [:tr {:class "cursor-pointer hover:bg-gray-50"
           :on-click (fn [e] (rf/dispatch [::model/open-questionnaire q]))}
      [:td {:class "px-6 py-4"} (:title q)]
      [:td {:class "px-6 py-4"} (:publisher q)]
      [:td {:class "px-6 py-4"} (:url q)]
      [:td {:class "px-6 py-4"} (:version q)]])])

(defn loinc-panel []
  (let [model @(rf/subscribe [::model/loinc-panel-model])]
    (when (:opened? model)
      [:div {:class "w-full"}
       [:input {:placeholder "Search..."
                :class "mb-4"
                :on-change #(rf/dispatch [:dispatch-debounce {:delay 300
                                                              :event [::model/search-loinc (.. % -target -value)]}])}]

       [:div {:class "shadow-sm border rounded-lg overflow-x-auto bg-white w-full"}
        [:table {:class "w-full table-auto text-sm text-left"}
         [:thead {:class "bg-gray-50 text-gray-600 font-medium border-b"}
          [:tr
           [:th {:class "py-3 px-6"} "Title"]
           [:th {:class "py-3 px-6"} "Publisher"]
           [:th {:class "py-3 px-6"} "URL"]
           [:th {:class "py-3 px-6"} "Version"]]]
         [:tbody {:class "text-gray-600 divide-y"}
          (cond
            (:loading? model)
            [:td {:col-span 4}
             [toolkit.spinner/spin]]

            (seq (:data model))
            [questionnaires-grid (:data model)]

            :else
            [:td {:col-span 4}
             [toolkit.empty/empty]])]]]])))

(defn importer-iframe []
  (let [token @(rf/subscribe [:zf/value {:zf/root [::model/db] :zf/path [:aidbox-token]}])]
    [:div {:class "w-[80rem] relative"}
     [:div {:class "h-full min-h-[600px]"
            :on-click (fn [e]
                        (println "parent div click")
                        (.preventDefault e)
                        (.stopPropagation e))}
      [:iframe {:width "100%"
                :class "h-full min-h-[600px]"
                :src (cond-> "/ui/sdc#forms/importer/?f=559087873"
                       token
                       (str "&token=" token))}]]]))

(defn user-avatar [userinfo]
  (let [given-name (get-in userinfo [:name :givenName])
        family-name (get-in userinfo [:name :familyName])
        full-name (get-in userinfo [:name :formatted])
        email (:email userinfo)
        display-name (or full-name (when (and given-name family-name) (str given-name " " family-name)) email "User")
        first-letter (or (first given-name) (first email) "U")]
    [:div {:class "relative group"}
     [:div {:class "flex items-center gap-2 cursor-pointer py-2 px-2 -mx-2 rounded-lg hover:bg-gray-100 transition-colors"}
      [:div {:class "w-8 h-8 rounded-full bg-violet-600 text-white flex items-center justify-center font-medium text-sm"}
       (str first-letter)]
      [:span {:class "text-sm text-gray-700 hidden sm:block"}
       display-name]]
     [:div {:class "absolute right-0 top-full pt-1 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50"}
      [:div {:class "w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2"}
       [:div {:class "px-4 py-3 border-b border-gray-100"}
        [:div {:class "font-medium text-gray-900"}
         display-name]
        [:div {:class "text-sm text-gray-500"}
         email]]
       [:button {:class "w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                 :on-click #(rf/dispatch [::model/logout])}
        "Logout"]]]]))

(defn hero-section []
  (let [userinfo @(rf/subscribe [::model/userinfo])]
    [:div {:class "relative isolate overflow-hidden bg-gray-50"}
     [:div {:class "mx-auto pt-12 pb-12 max-w-7xl"}
      [:div {:class "flex justify-between w-full items-center"}
       [:a {:href "https://www.health-samurai.io/aidbox" :target "_blank"}
        [:img {:class "h-12"
               :src "/assets/images/formbox.svg"}]]
       [:div {:class [:flex :items-center :gap-6]}
        [:a
         {:href "https://docs.aidbox.app/modules-1/aidbox-forms"
          :target "_blank"
          :class
          "inline-flex items-center space-x-2 text-sm font-medium leading-6 text-gray-600 cursor-pointer"}
         "Documentation"
         [:span {:aria-hidden "true"
                 :class "ml-1"} " →"]]
        [:a
         {:href "https://build.fhir.org/ig/HL7/sdc/"
          :target "_blank"
          :class
          "inline-flex items-center space-x-2 text-sm font-medium leading-6 text-gray-600 cursor-pointer"}
         "FHIR SDC Spec"
         [:span {:aria-hidden "true"
                 :class "ml-1"} " →"]]

        (if userinfo
          [user-avatar userinfo]
          [:button {:class "rounded border-violet-700 border-2 font-medium hover:bg-violet-700 text-violet-700 hover:text-white py-2 px-4"
                    :on-click #(rf/dispatch [::model/trigger-authorization "index"])
                    :id "sign-in-button"}
           "Sign in"])]]]
     [:div {:class "mx-auto max-w-7xl lg:flex gap-40"}
      [:div
       {:class
        "mx-auto max-w-2xl lg:mx-0 lg:max-w-xl lg:flex-shrink-0 lg:pt-8"}
       [:div {:style {:font-family "PT Mono"}
              :class [:text-lg]}
        [:span {:class "text-violet-700"} ">_"]
        [:span {:class "ml-2"} "Play with forms"]]
       [:h1
        {:class
         "mt-10 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl"}
        "Formbox Builder"
        [:span {:class "ml-3 inline-flex items-center rounded-full bg-violet-100 px-3 py-1 text-sm font-semibold text-violet-700 align-middle"}
         "Free"]]
       [:p
        {:class "mt-6 text-lg leading-8 text-gray-600"}
        "Design and test FHIR-native healthcare forms - instantly. Create digital clinical forms with logic, validation, multilingual support, and structured data capture."]
       [:div {:class "flex mt-5 gap-2"}
        [:a {:class "bg-violet-600 text-white font-medium px-4 py-2 whitespace-nowrap rounded"
             :id "create-new-form"
             :on-click (fn [_]
                         (rf/dispatch [::posthog/report-event {:event "box_sdc:public_builder:create-new-form" :properties {}}])
                         (rf/dispatch [::model/create-from-scratch-with-auth]))
             :href "#"} "Create new form"]
        [:a {:id "import-pdf"
             :class "text-violet-600 border-2 border-violet-600 font-medium px-4 py-2 whitespace-nowrap rounded cursor-pointer"
             :on-click (fn []
                         (rf/dispatch [::posthog/report-event {:event "box_sdc:public_builder:import-pdf-button" :properties {}}])
                         (rf/dispatch [::model/show-form-import-with-auth]))} "Import or convert"]]
       [:div
        {:class "my-5 flex items-center gap-x-6"}
        [:a
         {:href "https://www.health-samurai.io/medical-form",
          :on-click (fn [_]
                      (rf/dispatch [::posthog/report-event {:event "box_sdc:public_builder:aidbox-documentation" :properties {}}]))
          :id "aidbox-documentation"
          :target "_blank"
          :class "text-base font-semibold leading-6 text-violet-700"}
         "See Product Overview"
         [:span {:aria-hidden "true"} " →"]]]]
      [:div {:class "mx-auto flex-none max-w-none h-[25rem] rounded-tr rounded-tl"}
       [:img
        {:src "/assets/images/forms_builder.png",
         :width "1000px"
         :alt "App screenshot",
         :class
         "w-30 rounded-md shadow-2xl ring-1 ring-blue-900/10"}]]
      #_[:div
         {:class
          "mx-auto mt-16 flex max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0 lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32"}
         [:div
          {:class "max-w-3xl flex-none sm:max-w-5xl lg:max-w-none"}
          [:div
           {:class
            "-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4"}]]]]]))

(def webinar-url
  "https://www.health-samurai.io/events/sdc-in-production-webinar?utm_source=builder&utm_medium=popup&utm_campaign=sdc-in-production-webinar")

;; ponytail: local ratom + localStorage, no re-frame db entry — nothing else needs this state
(defn webinar-popup []
  (let [shown? #?(:cljs (r/atom false) :clj (atom false))
        close! (fn []
                 #?(:cljs (.setItem js/localStorage "webinar-popup-dismissed" "1"))
                 (reset! shown? false))]
    #?(:cljs
       (when-not (.getItem js/localStorage "webinar-popup-dismissed")
         ;; let the page paint first, then interrupt — an instant modal reads as an ad
         (js/setTimeout #(reset! shown? true) 1200)
         (.addEventListener js/document "keydown"
                            (fn [e] (when (= "Escape" (.-key e)) (close!))))))
    (fn []
      (when @shown?
        [:div {:class "fixed inset-0 z-50 flex items-center justify-center p-4"
               :role "dialog"
               :aria-modal "true"
               :aria-label "Upcoming meetup"
               :on-click close!}
         [:div {:class "absolute inset-0 bg-gray-900/50 backdrop-blur-sm"}]
         [:div {:class "relative isolate w-full max-w-lg overflow-hidden rounded-2xl bg-violet-700 text-white shadow-2xl"
                :on-click (fn [e] (.stopPropagation e))}
          ;; ponytail: radial washes for depth — cheaper than an image, no extra request
          [:div {:aria-hidden "true"
                 :class "pointer-events-none absolute inset-0"
                 :style {:background "radial-gradient(40rem 20rem at 10% -30%, rgb(167 139 250 / 0.6), transparent 70%), radial-gradient(30rem 18rem at 100% 120%, rgb(91 33 182 / 0.9), transparent 70%)"}}]
          [:button {:class "absolute right-4 top-4 z-10 text-2xl leading-none text-violet-300 transition hover:text-white"
                    :aria-label "Dismiss"
                    :on-click close!}
           "×"]
          [:div {:class "relative px-8 py-10"}
           [:span {:style {:font-family "PT Mono"}
                   :class "flex items-center gap-2 text-sm text-violet-200"}
            [:span {:class "relative flex h-2 w-2"}
             [:span {:class "absolute inline-flex h-full w-full animate-ping rounded-full bg-violet-300 opacity-75"}]
             [:span {:class "relative inline-flex h-2 w-2 rounded-full bg-violet-200"}]]
            "Upcoming meetup"]
           [:p {:class "mt-5 text-3xl font-bold leading-tight tracking-tight sm:text-4xl"}
            "SDC in Production:"
            [:span {:class "block text-violet-200"} "One Standard, Every Workflow"]]
           [:div {:class "mt-8 flex items-center gap-5"}
            [:a {:href webinar-url
                 :target "_blank"
                 :on-click (fn [_]
                             (rf/dispatch [::posthog/report-event {:event "box_sdc:public_builder:webinar-popup-click" :properties {}}])
                             (close!))
                 :class "group inline-flex items-center gap-2 rounded bg-white px-5 py-3 font-semibold text-violet-700 shadow-sm transition hover:bg-violet-50"}
             "Save your seat"
             [:span {:aria-hidden "true"
                     :class "transition-transform duration-200 group-hover:translate-x-1"} "→"]]
            [:button {:class "text-sm text-violet-200 transition hover:text-white"
                      :on-click close!}
             "Maybe later"]]]]]))))

(defn view []
  (let [model @(rf/subscribe [::model/model])
        selected-questionnaire @(rf/subscribe [::model/selected-questionnaire])]
    [:div {:class "bg-white"}
     [webinar-popup]
     [hero-section]
     [:div {:class "mx-auto max-w-7xl py-10 bg-white"}
      [:div {:class "py-10 sm:py-1"}
       [:div
        {:class "mx-auto max-w-7xl"}
        [:div
         {:class "mx-auto max-w-2xl lg:mx-0"}
         [:h2 {:class "text-4xl font-bold tracking-tight text-gray-900 sm:text-4xl"}

          "Form Gallery"]
         [:p
          {:class "mt-6 text-lg leading-8 text-gray-600"}
          "Start from scratch or pick from over 3000 ready-to-use forms"]]]]
      [:div {:class "mt-8 flex items-center gap-2"}
       [:div {:class "relative flex gap-2 sm:flex-auto"}
        [:input
         {:type "text",
          :on-change #(rf/dispatch [:dispatch-debounce {:delay 300
                                                        :event [::model/search-changed (.. % -target -value)]}])
          :class "block w-full rounded-md border-0 py-1.5 min-h-12 pl-2 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-violet-600 sm:text-sm sm:leading-6",
          :placeholder "Search in Gallery"}]
        (let [filter-enabled? @(rf/subscribe [::model/filter-enabled? :openehr-templates])]
          [:div {:class "absolute right-2 top-1/2 transform -translate-y-1/2"}
           [:button
            {:type "button"
             :on-click #(rf/dispatch [::model/toggle-form-filter :openehr-templates])
             :class ["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-violet-100 text-violet-800 hover:bg-violet-200 transition-colors"
                     (when filter-enabled?
                       "bg-violet-800 text-violet-100")]}

            "OpenEHR Templates"]])]]
      [:div {:class "mt-8 flow-root pb-20"}
       [:div {:class "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"}
        [:div {:class "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"}
         [:div {:class "overflow-hidden  sm:rounded-lg"}
          [:table {:class "min-w-full divide-y divide-gray-300"}
           [:thead
            [:tr
             [:th
              {:scope "col",
               :class
               "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"}
              "Title"]
             [:th
              {:scope "col",
               :class
               "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"}
              "Publisher"]
             [:th
              {:scope "col", :class "relative py-3.5 pl-3 pr-4 sm:pr-6"}
              [:span {:class "sr-only"} "Edit"]]]]
           (if (:loading? model)
             [:tbody {:class "divide-y divide-gray-200 bg-white"}
              [:tr
               [:td {:colSpan 3}
                [:div {:class "flex justify-center items-center min-h-20"}
                 [:span "Loading Questionnaires..."]]]]]

             [:tbody
              {:class "divide-y divide-gray-200 bg-white"}
              (for [q (:questionnaires model)]
                ^{:key (:id q)}
                [:<>
                 [:tr {:class "cursor-pointer"
                       :on-click #(rf/dispatch [::model/toggle-details (:id q)])}
                  [:td
                   {:class
                    "py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 cursor-pointer whitespace-nowrap w-1/2"}
                   (:title q)]
                  [:td
                   {:class "whitespace-nowrap px-3 py-4 text-sm text-gray-500"}
                   (if-let [publisher (:publisher q)]
                     publisher
                     "Health Samurai")]
                  #_[:td
                     {:class "whitespace-nowrap px-3 py-4 text-sm text-gray-500"}
                     ""]
                  [:td
                   {:class
                    "flex gap-3 justify-end relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"}
                   [:a
                    {:class "text-violet-600 hover:text-violet-900"
                     :id "preview-form"
                     :on-click (fn [e]
                                 (.preventDefault e)
                                 (.stopPropagation e)
                                 (rf/dispatch [::model/show-preview (select-keys q [:id :title])]))}
                    "Preview"]
                   [:a
                    {:id "open-form-in-builder"
                     :on-click (fn [e]
                                 (.preventDefault e)
                                 (.stopPropagation e)
                                 (rf/dispatch [::posthog/report-event {:event "box_sdc:public_builder:open-form-in-builder" :properties {}}])
                                 (rf/dispatch [::model/open-questionnaire-with-auth q]))
                     :href (str "#/builder/" (:id q))
                     :class "text-violet-600 hover:text-violet-900"}
                    "Open in Builder"
                    [:span {:class "sr-only"} ", Lindsay Walton"]]]]
                 (when (= (:id q) selected-questionnaire)
                   [:<>
                    [:tr {:class "bg-gray-50"}
                     [:td {:class "pl-6 py-4 text-sm font-medium"} "URL"]
                     [:td {:colSpan 3 :class "px-3 py-4 text-sm"} (:url q)]]
                    [:tr {:class "bg-gray-50"}
                     [:td {:class "pl-6 py-4 text-sm font-medium"} "Description"]
                     [:td {:colSpan 3 :class "px-3 py-4 text-sm"} (:description q)]]
                    [:tr {:class "border-none bg-gray-50"}
                     [:td {:class "pl-6 py-4 text-sm font-medium"} "Publisher"]
                     [:td {:colSpan 3 :class "px-3 py-4 text-sm"} (or (:publisher q) "Health Samurai")]]
                    [:tr {:class "border-none bg-gray-50"}
                     [:td {:class "pl-6 py-4 text-sm font-medium"} "Contact"]
                     [:td {:colSpan 3 :class "px-3 py-4 text-sm"} (str (get-in q [:contact 0 :name]) " "
                                                                       (->> (get-in q [:contact 0 :telecom])
                                                                            (map :value)
                                                                            (str/join ", ")))]]
                    [:tr {:class "border-none bg-gray-50"}
                     [:td {:class "pl-6 py-4 text-sm font-medium"} "Copyright"]
                     [:td {:colSpan 3 :class "px-3 py-4 text-sm"} (:copyright q)]]
                    #_[:td {:colSpan 4}
                       [:div {:class "bg-orange-500 grid grid-cols-2 text-sm"}
                        [:div {:class "pl-4 py-4 font-medium"} "URL"]
                        [:div {:class "py-4"} (:url q)]
                        [:div {:class "pl-4 py-4 font-medium"} "Publisher"]
                        [:div {:class "py-4"} (or (:publisher q) "Health Samurai")]
                        [:div {:class "pl-4 py-4 font-medium"} "Contact"]
                        [:div {:class "py-4"} (str (get-in q [:contact 0 :name]) " "
                                                   (->> (get-in q [:contact 0 :telecom])
                                                        (map :value)
                                                        (str/join ", ")))]
                        [:div {:class "pl-4 py-4 font-medium"} "Copyright"]
                        [:div {:class "py-4"} (:copyright q)]]]])])])
           [:tfoot {:class "bg-gray-50"}
            [:tr
             [:td {:colSpan 4}
              [:nav
               {:class
                "flex items-center justify-between px-4 py-3 sm:px-6",
                :aria-label "Pagination"}
               [:div
                {:class "hidden sm:block"}
                [:p {:class "text-sm text-gray-700"}
                 "Showing"
                 [:span {:class "font-medium px-1"} (get-in model [:showing :from])]
                 "to"
                 [:span {:class "font-medium px-1"} (get-in model [:showing :to])]
                 "of"
                 [:span {:class "font-medium px-1"} (get-in model [:showing :total])]
                 "results"]]
               [:div
                {:class "flex flex-1 justify-between sm:justify-end"}
                (when-let [previous-page (:previous-page model)]
                  [:a
                   {:href (str "#?page=" previous-page),
                    :class
                    "relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0"}
                   "Previous"])
                (when-let [next-page (:next-page model)]
                  [:a
                   {:href (str "#?page=" next-page),
                    :class
                    "relative ml-3 inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0"}
                   "Next"])]]]]]]]]]]]
     [toolkit.modal/dialog :form-import
      [:span {:class [:text-3xl :font-bold]} "Import or convert"]
      [importer-iframe]]
     [toolkit.modal/dialog :form-preview
      [:span {:class [:text-3xl :font-bold]} "Form preview"]
      (let [preview-form-id @(rf/subscribe [::model/form-preview-id])]
        [:div {:class "w-[80rem] relative"}
         [:div {:class "h-full min-h-[600px]"
                :on-click (fn [e]
                            (println "parent div click")
                            (.preventDefault e)
                            (.stopPropagation e))}
          [:iframe {:width "100%"
                    :class "h-full min-h-[600px]"
                    :src (str "/ui/sdc#questionnaire/" preview-form-id "?f=16777217")}]]])]
     [toolkit.modal/dialog :auth-sign-in
      [:span {:class [:text-3xl :font-bold]} "Sign in"]
      [:div {:class "w-[24rem] py-6 flex flex-col items-center gap-6"}
       [:p {:class "text-gray-600 text-center"}
        "Sign in with your Aidbox account to create and edit forms."]
       [:a {:class "bg-violet-600 text-white font-medium px-4 py-2 whitespace-nowrap rounded cursor-pointer"
            :on-click #(rf/dispatch [::model/do-authorization])}
        "Sign in"]]]]))

(pages/reg-page ::model/ctx view)
